import checkCircle from '../../images/check-circle.svg';
import batteryCharging from '../../images/battery-charging.svg';
import calendarMock from '../../images/calendar-mock-2.svg';

export const accordianData = [
  {
    title: 'Instant task capture',
    content:
      'Global shortcuts to capture tasks, in-meeting task taker, and direct capture from your favourite apps like Slack, Asana etc.',
    icon: checkCircle,
    image: calendarMock,
  },
  {
    title: 'Plan and schedule tasks in one drag',
    content:
      'Prioritize and commit to your important tasks by scheduling them on your calendar.',
    icon: batteryCharging,
    image: calendarMock,
  },
  {
    title: 'Simplify balance of collaboration and deep work',
    content:
      'Aerotime keeps your calendar available for meetings even when tasks are there, but when you hit a busy threshold it shields your time.',
    icon: batteryCharging,
    image: calendarMock,
  },
];
